import React, { Component } from 'react';
import { Form, Modal } from 'antd';
import UploadFile from '@comm/upload/UploadFile';
import { queryDownloadHrTemplate } from '@api/hr/hr';

const FormItem = Form.Item;

class ModalImport extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleOk = () => {
    const {
      handleSubmit,
      form: { validateFields },
    } = this.props;
    validateFields((err, values) => {
      if (!err) {
        const params = {
          fileUuid: values.files[0].uuid,
        };
        handleSubmit(params);
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Modal
        title="人员导入"
        onOk={this.handleOk}
        onCancel={this.props.handleCancel}
        visible={this.props.visible}
      >
        <Form>
          <FormItem label="请上传Excel文件">
            {getFieldDecorator('files', {
              rules: [{ required: true, message: '请上传Excel文件' }],
            })(<UploadFile limit={1} type="ghost" isPreview />)}
            <a onClick={() => queryDownloadHrTemplate()}> 点击下载模板</a>
          </FormItem>
        </Form>
      </Modal>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(ModalImport);



// WEBPACK FOOTER //
// ./src/components/hr/staff/ModalImport.js